import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'pedidos',
})
export class PedidosPipe implements PipeTransform {


  transform(items: any[], filter: any[]) {

    if (filter && items) {

      if (filter['id_estado'] > 0) {

        items = items.filter(function (item) {
          return item.id_estado == filter['id_estado'];
        });
      }

      if (filter['id_proveedor'] > 0) {

        items = items.filter(function (item) {
          return item.id_proveedor == filter['id_proveedor'];
        });
      }

      if (filter['id_local'] && filter['id_local'] > 0) {

        items = items.filter(function (item) {
          return item.id_local == filter['id_local'];
        });
      }


      items = items.filter(function (item) {
        return item.sugerido == filter['sugerido'];
      });

    }

    return items;

  }

}



// WEBPACK FOOTER //
// ./src/pipes/pedidos/pedidos.ts